import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ButtonCopy = (props) => {
  const { string } = props;
  const [tipText, setTipText] = useState("Copiar");

  const copy = () => {
    navigator.clipboard.writeText(string);
    setTipText("Copiado!");

    setTimeout(() => {
      setTipText("Copiar");
    }, 2000);
  };

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-top">{tipText}</Tooltip>}
      >
        <FontAwesomeIcon
          icon={faCopy}
          className="ms-2"
          onClick={copy}
          style={{ cursor: "pointer", fontSize: "1.2em" }}
        />
      </OverlayTrigger>
    </>
  );
};

export default ButtonCopy;
